/** QuickTicketing — Pastilles d'état et de priorité. */
import React from 'react';

export function StatusBadge({ status, meta }) {
  const s = meta.statuses.find((x) => x.id === status);
  return <span className={`badge st-${status}`} title={s?.hint}>{s?.label ?? status}</span>;
}

export function PriorityTag({ priority }) {
  if (!priority) return <span className="muted">—</span>;
  return <span className={`prio prio-${priority}`}>{priority}</span>;
}
